<template>
  <div class="content-box">

    <div class="sub-catalog">
        <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
                <el-breadcrumb-item>字庫調用</el-breadcrumb-item>
                <el-breadcrumb-item>{{article.article_name}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="sub-line"></div>



    <div class="content">
          <div class="left-box">
            <div class="row1">
              <div class="talk-title">{{article.article_name}}</div>
              <div class="author-time">
                  <div>作者：<span>{{article.author}}</span></div>
                  <div>時間：<span>{{article.endtime}}</span></div>
              </div>
            </div>
            <div class="row2">
                <div class="article_content">
                    <span>{{article.article_content}}</span>
                </div>
            </div>
          </div>

          <div class="right-box">
            <div class="rbc">
              <div class="rbc-t">項目名稱</div>
              <div class="rbc-title">{{proj.proj_title}}</div>
            </div>
            <div class="rbc">
              <div class="rbc-t">項目簡介</div>
              <div class="rcb-detail">{{proj.proj_detail}}</div>
            </div>
            <div class="rbc">
              <div class="rbc-t">文章列表</div>
              <div v-for="(item,index) in articlelist" :key="index"  :value="item.ID" class="rbc-t-box">
                <div  @click="tclick(item.ID)" @mouseover="tover()" class="rbc-title">{{item.article_name}}</div>
                <div class="rbc-c">
                  <div class="rbc-c-t1">
                    <div >{{item.author}}</div>
                    <div >{{item.endtime}}</div>
                  </div>
                  <div class="rbc-c-t2">{{item.article_type}}</div>
                </div>
              </div>
              
            </div>

          </div>

    </div>
  </div>
</template>


<script>
export default {
  name: "app",
  data() {
    return {
      projid:this.$route.query.id,
      articlelist:[],
      proj:[],
      article:[],
      
    };
  },
  methods: {
    tover(){

    },
    tclick(aid){
      this.$http
      .get(`${this.$store.state.baseurl}/api/hgarticle/getarticledetail?id=`+aid)
      .then((res) => {
        const json = res.data;
        let pinfo=JSON.parse(json);
        this.article=pinfo.data[0];
        
      });

    },

    
  },
  created() {
    this.$http
      .get(`${this.$store.state.baseurl}/api/hgsub/getsubdetail?id=`+this.projid+"&t=1")
      .then((res) => {
        const json = res.data;
        let pinfo=JSON.parse(json);
        this.articlelist=pinfo.data;
        this.proj=pinfo.data2[0];
        if(this.articlelist.length>0){
          this.article=this.articlelist[0];
        }
        
      });
    
  },
};
</script>



<style scoped lang="scss">
.content-box {
    display: flex;
    flex-direction: column;
    min-height:800px;
    width: 100%;
    background-color: #e5e2db;
    border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
    
}
.sub-catalog{
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  font-size: 14px;
  color: #666666;
  padding-top: 14px;
  padding-bottom: 14px;
  
}
.sub-line{
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}
.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .left-box{
    width: 900px;
    min-height: 800px;
    border-width: 0px 1px 0px 0px ;
	  border-style: solid;
	  border-color:#cec0b2;
    .article_content{
      color: #333;
      word-break: break-all;
    }

    .row1{
        border-width: 0px 0px 1px 0px ;
        border-style: dotted;
        border-color:#cec0b2;
        width: 900px;
        .talk-title{
            padding: 15px 25px 0px 25px;
            text-align: left;
            font-size: 20px;
            font-weight: 600;
        }
        .author-time{
            display: flex;
            flex-direction: row;
            justify-content: start;
            flex-wrap: wrap;
            color: #666666;
            div{
                padding: 15px 25px;
            }
        }
     }

     .row2{
         padding: 25px 25px;
         
         
     }

     
  }
  

     
        
  
}

.right-box{
    width: 300px;
    .rbc{
       padding: 10px 15px;
       .rcb-detail{
        color: #666;
         word-break: break-all;
       }
       .rbc-title{
         word-break: break-all;
         margin-top: 15px;
         cursor: pointer;
         
       }
       .rbc-t{
         font-size: 16px;
         margin: 5px 0px;
         color:#987154

       }
       .rbc-c{
        display: flex;
        flex-direction: row;
        justify-content: start;
        flex-wrap: wrap;
        width: 270px;
        border-width: 0px 0px 1px 0px ;
        border-style: dotted;
        border-color:#cec0b2;
        padding: 10px 0px;
        .rbc-c-t1{
          display: flex;
          flex-direction: row;
          justify-content: start;
          flex-wrap: wrap;
          width: 190px;
          div{
            font-size: 14px;
            padding: 0px 10px;
            color: #666666;
          }
        }
        .rbc-c-t2{
          padding: 0px 5px;
          width: 50px;
        }

       }
      }
  }







</style>